import { render } from "./Pagamento.vue?vue&type=template&id=71d2748c&scoped=true"
import script from "./Pagamento.vue?vue&type=script&lang=js"
export * from "./Pagamento.vue?vue&type=script&lang=js"

import "./Pagamento.vue?vue&type=style&index=0&id=71d2748c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d2748c"]])

export default __exports__